import { actionTypes } from "./actions";

const initialState = {
  transactions: [],
  totalRevenue: 0, // Add totalRevenue to the initial state
};

export const transactions = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.data,
      };
    case actionTypes.SET_TOTAL_REVENUE:
      return {
        ...state,
        totalRevenue: action.amount, // Update totalRevenue in the state
      };
    default:
      return state;
  }
};

export default transactions;